import { NgStyle } from '@angular/common';
import { afterNextRender, ChangeDetectionStrategy, Component, input, signal } from '@angular/core';

import { Dynamic } from '@shared/registry/dynamic';

import { type GoalCardConfig } from './goal-card.types';

@Component({
  selector: 'app-goal-card',
  templateUrl: './goal-card.html',
  imports: [Dynamic, NgStyle],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoalCard {
  readonly config = input.required<GoalCardConfig>();

  protected readonly backgroundStyle = signal<Record<string, string>>({});

  constructor() {
    afterNextRender(() => {
      const gradient = getComputedStyle(document.documentElement)
        .getPropertyValue('--goalcard-background-gradient')
        .trim();

      this.backgroundStyle.set({
        background: `linear-gradient(180deg, var(--gradients-${gradient}-start), var(--gradients-${gradient}-middle), var(--gradients-${gradient}-stop))`,
      });
    });
  }
}
